

<template>
    <l-map ref="map1" 
        style="height: 600px;"  
        :center="center" 
        :zoom="zoom" >
    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
    <l-marker-cluster>
        <l-marker
            v-for="(location, markerIndex) in locations"
                :key="'marker-' +  markerIndex"
                :lat-lng="{
                    lat: location.latitude,
                    lng: location.longitude
                }"
                :icon="getIcon(location.color)"> 
                <l-popup  :opened="markerIndex === 0 || undefined">
                    <span v-if="location.date!=undefined"><b>Date</b> : {{ location.date}} <br></span>
                    <span v-if="location.start!=undefined"><b>Debut d'activité</b> : {{ location.start}} <br></span>
                    <span v-if="location.end!=undefined"><b>Fin d'activité</b> : {{ location.end}} <br></span>
                    <span v-if="location.cumul_time!=undefined"><b>Durée d'utilisation</b> : {{parseFloat((location.cumul_time/360).toFixed(0))/10 + " heures"}} <br></span>
                    <span v-if="location.cumul!=undefined"><b>Cumul d'activité</b> : {{parseFloat((location.cumul*10).toFixed(0))/10}} {{ location_info.unit_title_label}}</span>
                </l-popup>
        </l-marker>
    </l-marker-cluster>

    <l-circle
        v-for="(location,circleIndex) in locations"
            :key="'circle-' + circleIndex"
            :lat-lng="{
                lat: location.latitude,
                lng: location.longitude
            }"
            :radius="location.precision"
            :color="location.color">
    </l-circle>
   <!-- <l-polyline :lat-lngs="locations.map(location => [location.latitude, location.longitude])" color="black" :weight="parseInt('1.0')" :smoothFactor="95.0" :noClip="true"></l-polyline>-->
  </l-map>
</template>


<script>
    import L from 'leaflet';
    import 'leaflet.markercluster';
    import { LMap, LTileLayer, LMarker,LCircle, LPopup, LMarkerCluster, LPolyline, LCircleMarker } from 'vue2-leaflet';
    import { mapGetters } from 'vuex';
    import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster'

    export default {
        name: 'Map1',
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            LCircle,
            LPolyline,
            LCircleMarker,
            'l-marker-cluster': Vue2LeafletMarkercluster,
        },
        //props: heritage d'un composant parent
        props: {
            location_info: {//heritage du composant parent permettant de recevoir le sensor, rental, système choisi
                type: Object,
                required: true,// props obligatoire doit être passer par le parent
                default: function () {
                    return {
                        id: 1,
                        geolocation_points: [{
                          /*  geolocation_type:null,
                            geolocation_precision: 5000,
                            latitude: 0,
                            longitude: 0,
                            SDate: '2021-08-30', */
                        }]
                    }
                }
            }
        },
        data () {
            return {
                zoom: 0,
                center: [0,0],
                locations: [
                   /* {last_update: "",latitude: 0.0,longitude: 0.0,radius: 10,color: "red"},
                    {last_update: "",latitude: 0.0,longitude: 0.0,radius: 10,color: "red"}*/
                ],

                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            };
        },

        computed: {
			...mapGetters({
                structure : 'structure/structure'
            }),            
        },
       
       
        mounted() {
            this.$data.locations = this.location_info.geolocation_points.map((point, index) => {
                return {
                    //id: point.id,
                    latitude: point.latitude*1.0,
                    longitude: point.longitude*1.0,
                    precision: point.geolocation_precision*1,
                    date: point.SDate,
                    start : point.start,
                    end : point.end,
                    cumul_time: point.cumul_time, //en heure
                    cumul: point.cumul_terrain_converted,
                    type: point.geolocation_type,
                    color: index === 0 ? 'red' : 'blue', // vérifie si l'élément en cours est le premier élément de la listecolor: index === 0 ? 'red' : 'blue'
                    radius: point.geolocation_precision*1
                }
            });
            
            if (this.locations.length > 0) {
                const sum = this.locations.reduce((accumulator, location) => {
                    return [accumulator[0] + location.latitude, accumulator[1] + location.longitude];
                }, [0, 0]);
                const average = [sum[0] / this.locations.length, sum[1] / this.locations.length];
                this.$set(this, 'center', average);
            }

            if (this.locations.length > 1) {
                const latitudes = this.locations.map(l => l.latitude);
                const longitudes = this.locations.map(l => l.longitude);
                var latRange = Math.max(...latitudes) - Math.min(...latitudes);
                var lngRange = Math.max(...longitudes) - Math.min(...longitudes);
                var maxRange = Math.max(latRange, lngRange);
                maxRange = maxRange*Math.PI/180;
                latRange = latRange*Math.PI/180;
                lngRange = lngRange*Math.PI/180;
                var a = Math.sin(latRange/2) * Math.sin(latRange/2) +
                    Math.cos(Math.max(...latitudes) * Math.PI / 180) * Math.cos(Math.min(...latitudes) * Math.PI / 180) *
                    Math.sin(lngRange/2) * Math.sin(lngRange/2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
                var R = 6378.137; // Radius of earth in KM
                var d = R * c*1000;
                this.zoom = Math.min(16, parseInt(Math.log2(591657550.5 / (d * 180))) + 3);
            }
            else if(this.locations.length == 1){
                this.zoom = Math.min(16,parseInt(Math.log2(591657550.5 / (this.locations[0].precision * 180))) + 2);
            }

            setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
            }, 250);
           
        },

        methods: {
            getIcon(color) {
                return L.icon({
                    iconUrl: `https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    tooltipAnchor: [16, -28],
                    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png',
                    shadowSize: [41, 41],
                    shadowAnchor: [12, 41]
                });
            },
        },
    };

</script>

<style>
  @import "~leaflet/dist/leaflet.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
  
</style>
        